import moment from 'moment'

export function requiresFetch(span, currentHorizon) {
    if (!span) {
        return
    }

    // if there is no current horizon, then we are signalling the need to fetch
    if (!currentHorizon) {
        return true
    }

    let { clickSize, momentStart, momentEnd } = calculateSpanDetail(span)

    let horizonStart = moment(currentHorizon.start)
    let horizonEnd = moment(currentHorizon.end)

    let horizonStartTrigger = horizonStart.add( clickSize, 'days' )
    let horizonEndTrigger = horizonEnd.subtract( clickSize, 'days' )

    // console.log("horizonStart", new Date(horizonStart.valueOf()))
    // console.log("horizonEnd", new Date(horizonEnd.valueOf()))
    // console.log("horizonStartTrigger", new Date(horizonStartTrigger.valueOf()))
    // console.log("horizonEndTrigger", new Date(horizonEndTrigger.valueOf()))

    if ( !horizonStart.isValid() || !horizonEnd.isValid() ) {
        return true
    }

    if ( momentStart.isSameOrBefore(horizonStartTrigger) ) {
        return true
    }

    if ( momentEnd.isSameOrAfter(horizonEndTrigger) ) {
        return true
    }

    return false
}

/**
 *                  span start                span end
 *                  /-------------------------/
 *
 *                  click size (half of span size)
 *                  /------------/
 */
export function calculateHorizon(span, horizonFactor=3) {
    if (horizonFactor < 1) {
        return
    }

    if (!span) {
        return
    }

    let {start, end} = span
    if (!start || !end) {
        return
    }

    if (start > end) {
        return
    }

    // normalize the start and end days

    let { clickSize, momentStart, momentEnd } = calculateSpanDetail(span)
    let edgeSubtractor = clickSize * horizonFactor

    // console.log("clickSize", clickSize)
    // console.log("diffDays", diffDays)
    // console.log("edgeSubtractor", edgeSubtractor)

    return {
        start: momentStart.subtract(edgeSubtractor, 'days').valueOf(),
        end: momentEnd.add(edgeSubtractor, 'days').subtract(1, 'second').valueOf(),
    }
}

function calculateSpanDetail(span) {
    let { start, end } = span
    let momentStart = moment(start).startOf('day')
    let momentEnd = moment(end).endOf('day')

    let width = momentEnd.add(1, 'second').diff(momentStart, 'days')
    let clickSize = width / 2

    return { width, clickSize, momentStart, momentEnd }
}


// WEBPACK FOOTER //
// ./src/util/horizon_utils.js